// extracted by extract-css-chunks-webpack-plugin
module.exports = {"muted":"muted___1DPWQ","label":"label___Y6331","rightLabel":"rightLabel___2MqU_"};